import PropTypes from 'prop-types';
import React from 'react';

import Icon from 'dpl/common/components/Icon';
import MiniOverlayModal from 'dpl/common/mini_overlay_modal/components/MiniOverlayModal';
import MediaCarousel from 'dpl/components/MediaCarousel';
import {
  EXPLORE_PHOTO_ALBUM_CAPTION_HEIGHT,
  PHOTO_ALBUM_VERTICAL_PADDING
} from 'dpl/constants/photo_album';

const WIDTH_CSS = `calc(100vh - ${
  EXPLORE_PHOTO_ALBUM_CAPTION_HEIGHT + PHOTO_ALBUM_VERTICAL_PADDING
}px)`;

export default function ExplorePhotoAlbum({
  setImage,
  onClose,
  currentImage,
  nextImage,
  previousImage,
  imagesOrderedByCategory
}) {
  return (
    <MiniOverlayModal
      hideCloseButton
      scrollableContent
      onCloseClick={onClose}
      contentClassName="bg-none"
      maxWidth={WIDTH_CSS}
    >
      <div className="ExplorePhotoAlbum h-100 flex flex-column center bg-black">
        <button
          onClick={onClose}
          className="white pv5 pl5 absolute top-0 left-0 d-md-none z-max"
          type="button"
        >
          <span className="mr4 f5 v-mid">&larr;</span>
          Breed explorer
        </button>
        <div className="flex-auto h-100 flex flex-column justify-center relative">
          <div className="ExplorePhotoAlbum__imageCarousel w-100 h-100 absolute-ns">
            <MediaCarousel
              files={imagesOrderedByCategory}
              arrowClassName="d-none"
              onFileChange={setImage}
              currentFile={currentImage}
              bulletsContainerClassName="d-md-none"
              smartImageProps={{
                className:
                  'transform-center left-0 right-0 max-h-100 h-100 h-auto center',
                imageOnlyClassName: 'max-h-100 h-auto',
                loadingClass: 'h-100 loading-spinner',
                alt: currentImage.alt_text || currentImage.caption
              }}
            />
          </div>
          {currentImage.source_name && (
            <p className="absolute-ns white bottom-0 left-0 pv2 pl2 text-shadow f2 tc tl-m tl-l">
              src:&nbsp;
              <a className="underline" href={currentImage.source_url}>
                {currentImage.source_name}
              </a>
            </p>
          )}
        </div>
        <div
          style={{ height: `${EXPLORE_PHOTO_ALBUM_CAPTION_HEIGHT}px` }}
          className="mb6 mb0-sm"
        >
          <a
            href={`/${currentImage.breed_slug}`}
            className="button inline-flex items-center justify-center h-100 w-100 bg-white black bw2 truncate"
          >
            View {currentImage.breed_name} Breeders
          </a>
        </div>
        <button
          className="left-0 transform-center nh14 d-none d-md-block"
          onClick={() => setImage(previousImage.id)}
          type="button"
        >
          <Icon
            className="light-gray"
            height="40px"
            name="arrow-left"
            width="40px"
          />
        </button>
        <button
          className="right-0 transform-center nh14 d-none d-md-block"
          onClick={() => setImage(nextImage.id)}
          type="button"
        >
          <Icon
            className="light-gray"
            height="40px"
            name="arrow-right"
            width="40px"
          />
        </button>
      </div>
    </MiniOverlayModal>
  );
}

ExplorePhotoAlbum.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  imagesOrderedByCategory: PropTypes.array.isRequired,
  onClose: PropTypes.func.isRequired,
  setImage: PropTypes.func.isRequired,
  nextImage: PropTypes.shape({
    id: PropTypes.number.isRequired
  }).isRequired,
  previousImage: PropTypes.shape({
    id: PropTypes.number.isRequired
  }).isRequired,
  currentImage: PropTypes.shape({
    breed_slug: PropTypes.string.isRequired,
    breed_name: PropTypes.string.isRequired,
    source_name: PropTypes.string,
    source_url: PropTypes.string,
    alt_text: PropTypes.string,
    caption: PropTypes.string
  }).isRequired
};
